// WebSocket Configuration
export const WEBSOCKET_CONFIG = {
  URL: process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000',
  // Use empty string for default namespace, or specific namespace if provided
  NAMESPACE: process.env.REACT_APP_WEBSOCKET_NAMESPACE || '',
  ENABLED: process.env.REACT_APP_ENABLE_WEBSOCKET === 'true',
  RECONNECTION_ATTEMPTS: 5,
  RECONNECTION_DELAY: 1000,
  TIMEOUT: 20000
};

// Sync States
export const SYNC_STATES = {
  IDLE: 'idle',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  SYNCING: 'syncing',
  COMPLETED: 'completed',
  ERROR: 'error',
  CANCELLED: 'cancelled'
};

// WebSocket Events
export const WS_EVENTS = {
  // Client to Server
  JOIN_JOB: 'join_job',
  LEAVE_JOB: 'leave_job',
  GET_JOB_STATUS: 'get_job_status',
  PING: 'ping',
  
  // Server to Client
  SYNC_PROGRESS: 'sync_progress',
  SYNC_COMPLETE: 'sync_complete',
  SYNC_ERROR: 'sync_error',
  PONG: 'pong',
  
  // Connection Events
  CONNECT: 'connect',
  CONNECTED: 'connected',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  RECONNECT: 'reconnect',
  AUTHENTICATION_ERROR: 'authentication_error'
};

// Progress Messages based on percentage
export const PROGRESS_MESSAGES = {
  0: 'Initializing sync process...',
  5: 'Validating authentication...',
  10: 'Connecting to project board...',
  15: 'Fetching board configuration...',
  20: 'Loading project data...',
  25: 'Processing board items...',
  30: 'Fetching time tracking data...',
  35: 'Synchronizing Monday.com data...',
  40: 'Processing time entries...',
  45: 'Calculating work hours...',
  50: 'Updating time logs...',
  55: 'Processing team data...',
  60: 'Validating data integrity...',
  65: 'Calculating project totals...',
  70: 'Generating reports...',
  75: 'Updating board status...',
  80: 'Saving changes...',
  85: 'Finalizing synchronization...',
  90: 'Creating activity log...',
  95: 'Completing sync process...',
  100: 'Sync completed successfully!'
};

// Error Messages
export const ERROR_MESSAGES = {
  WEBSOCKET_CONNECTION_FAILED: 'Failed to connect to real-time server',
  WEBSOCKET_AUTHENTICATION_FAILED: 'Authentication failed for real-time connection',
  WEBSOCKET_TIMEOUT: 'Real-time connection timeout',
  SYNC_START_FAILED: 'Failed to start synchronization',
  SYNC_TIMEOUT: 'Synchronization timeout (maximum 10 minutes exceeded)',
  INVALID_BOARD_ID: 'Invalid board ID provided',
  UNAUTHORIZED_ACCESS: 'Unauthorized access to board',
  SERVER_ERROR: 'Server error occurred during synchronization'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  WEBSOCKET_CONNECTED: 'Connected to real-time server',
  SYNC_COMPLETED: 'Project synchronized successfully',
  SYNC_CANCELLED: 'Synchronization cancelled by user'
};

// Timeouts (in milliseconds)
export const TIMEOUTS = {
  WEBSOCKET_CONNECTION: 20000, // 20 seconds
  SYNC_OPERATION: 600000, // 10 minutes
  AUTO_HIDE_SUCCESS: 5000, // 5 seconds
  AUTO_HIDE_ERROR: 10000, // 10 seconds
  RETRY_DELAY: 3000 // 3 seconds
};

const websocketConstants = {
  WEBSOCKET_CONFIG,
  SYNC_STATES,
  WS_EVENTS,
  PROGRESS_MESSAGES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  TIMEOUTS
};

export default websocketConstants;